import React, { useMemo } from 'react'
import { Col, Image, Row } from 'react-bootstrap'
import { FlameTier, FlameTiers, TierAccessTypes } from '@contracts/hooks/useFlameTier/constants'
import './FlameLevel.scss'
import { usePlatformSettings } from '@hooks/usePlatformSettings'
import { numberToCurrency } from '@firestarter-private/firestarter-library/lib/utils/bigNumbers'

interface Props {
  currentTier: FlameTier | null
}

const FlameLevel = ({ currentTier }: Props) => {
  const { settings } = usePlatformSettings()
  const tiers = useMemo(() => settings?.tiers ?? [], [settings])

  const tierIndex = useMemo(() => {
    return tiers.findIndex(t => t.name === currentTier)
  }, [currentTier, tiers])

  const overlayWidth = useMemo(() => {
    const startOffset = 8
    if (tierIndex === -1) {
      return startOffset
    }
    if (tierIndex === tiers.length - 1) {
      return 100
    }
    const oneTierWidth = (100 - startOffset) / tiers.length
    return startOffset + oneTierWidth * (tierIndex + 1)
  }, [tierIndex, tiers])

  return (
    <Row className="heat-row gx-0">
      <Col className="text-left column">
        <div className="color-strip">
          <div
            className='color-strip__overlay'
            style={{
              width: `${overlayWidth}%`
            }}
          />
        </div>
        <div className="progress">
          <div className="item">
            <div className="icon" />
            <div className="title">Start</div>
          </div>
          {
            tiers.map((tier) => (
              <div key={tier.name} className="item">
                <div className="icon">
                  <Image src={tier.icon} />
                </div>
                <div className="description">
                  <div className="title">
                    {tier.name.toLowerCase()}
                  </div>
                  <div className="subtitle">
                    {numberToCurrency(tier.min_flame_power)}+ FLAME POWER
                  </div>
                  <p>
                    {
                      tier.access_type === TierAccessTypes.SURPRISE_LOTTERY
                        ? <>Surprise Lottery <br/> Round</>
                        : <>First Come - <br/> First Served</>
                    }
                  </p>
                </div>
              </div>
            ))
          }
        </div>
      </Col>
    </Row>
  );
};

FlameLevel.defaultProps = {
  currentTier: null
}

export { FlameLevel }
